<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <!-- <v-card class="box"> -->
            <v-toolbar dense class="toolbar" flat>
                <v-toolbar-title>Employee Account Information</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row dense>
                <v-col cols="12" sm="3" md="3"> <v-icon color="error">*</v-icon><v-text-field  :rules="[rules.required, rules.email]" label="Enter Email Id" rounded outlined dense v-model="official_email_id"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field type="text" class="pt-6" label="Enter PF No" rounded outlined dense v-model="pfno"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field type=""  class="pt-6" label="Enter UAN No" rounded outlined dense v-model="uan_no"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field type=""  class="pt-6" label="Enter PAN No" rounded outlined dense v-model="pan_no"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field type="number"  class="pt-6" label="Enter Gratuity No" rounded outlined dense v-model="gratuity_number"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"><v-icon color="error">*</v-icon> <v-text-field  type="number" label="Enter Bank Account No" rounded outlined dense v-model="bank_account_number"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"><v-icon color="error">*</v-icon><v-autocomplete  rounded outlined dense v-model="bank" return-object :items="bank_org_list" item-text="bname" item-value="bid" label="Select Bank" /></v-col>
                <v-col cols="12" sm="3" md="3"> <v-icon color="error">*</v-icon><v-text-field  label="Enter IFSC Code" rounded outlined dense v-model="ifsc_code"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3"> <v-text-field type="number"  class="pt-6" label="Enter Last PF No" rounded outlined dense v-model="last_pfno"></v-text-field></v-col>
                 <v-col cols="12" sm="3" md="3"> <v-text-field type="number"  class="pt-6" label="Enter ESIC No" rounded outlined dense v-model="esic_no"></v-text-field></v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="error">*</v-icon><v-text-field  @blur="date = parseDate(dateofjoining)" hint="YYYY/MM/DD format" persistent-hint v-model="dateofjoining" label="Date Of Joining" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="dateofjoining" @input="menu3 = false"></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-menu v-model="menu11" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field  class="pt-8" @blur="date = parseDate(dateofretirement)" hint="YYYY/MM/DD format" persistent-hint v-model="dateofretirement" label="Date Of Retirement" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker v-model="dateofretirement" @input="menu11 = false"></v-date-picker>
                    </v-menu>
                </v-col>
             </v-row>
            <v-row dense justify="center">
                <v-btn @click="saveEmpPayRollInfo();show=true" v-if="official_email_id && bank_account_number && bank && ifsc_code && dateofjoining" class="button">Save / Update</v-btn>
            </v-row>
        <!-- </v-card> -->
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
         props: {
            instid: Number,
        },
        data() {
            return {
                rules: {
                    required: value => !!value || 'Required.',
                    counter: value => value.length <= 20 || 'Max 20 characters',
                    email: value => {
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    },
                },
                menu: false,
                modal: false,
                modal2: false,
                modal3: false,
                menu2: false,
                menu3: false,
                menu11: false,
                emppersonname: "",
                empdesignation: null,
                emptypename: null,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                search: "",
                load: false,
                emplist: {},
                official_email_id: null,
                pfno: null,
                uan_no: null,
                pan_no: null,
                gratuity_number: null,
                last_pfno: null,
                esic_no: null,
                bank_account_number: null,
                bank: null,
                ifsc_code: null,
                dateofjoining: null,
                dateofretirement: null,
                dob: null,
                employeetype: null,
                employeesection:null,
                iscurrentlyworking: false,
                is_eligible_for_increment: false,
                is_handicap: false,
                is_house_provided: false,
                is_car_provided: false,
                is_parmanant_salary_blocked: false,
                is_parmanant_salary_slip_blocked: false,
                empdetailslist: {},
                emp_type_list: [],
                emp_section_list: [],
                emp_data_list: [],
                bank_org_list: [],
                show: false,
            };
        },
        mounted() {
            this.load = false;
           this.getEmpPayRollInfo()
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            validEmail(email) {
                //alert("in valid")
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if (re.test(email)) {
                       // alert("Please Check Your email id");
                        return true;
                    }
                return false;
            },
            saveEmpPayRollInfo() {
                 if(this.hasWhiteSpace(this.official_email_id)){
                    this.showSnackbar("#b71c1c", "Please Enter Email Id");
                    return
                 }
                 if(!this.validEmail(this.official_email_id)){
                    this.showSnackbar("#b71c1c", "Please Enter Valid Email Id");
                    return
                 }
                var dor
                if(this.dateofretirement == null){
                    dor = "NA"
                }
                else{
                    dor = this.dateofretirement
                }
                const data = {
                    uan_no : this.uan_no,
                    pan_no : this.pan_no,
                    instid: this.instid,
                    official_email_id: this.official_email_id,
                    pfno: this.pfno,
                    pfno: this.pfno,
                    gratuity_number: this.gratuity_number,
                    bank_account_number: this.bank_account_number,
                    last_pfno: this.last_pfno,
                    esic_no: this.esic_no,
                    bank: this.bank.bid,
                    ifsc_code: this.ifsc_code,
                    dateofjoining: this.dateofjoining,
                    dateofretirement: dor,
                };
                axios
                    .post("/EmployeeProfile/saveEmpAccountDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Saved successfully!!!");
                            this.getEmpPayRollInfo()
                        }
                        else{
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                        this.empid = null
                        this.show = false,
                        this.official_email_id = null
                        this.pfno = null
                        this.uan_no = null
                        this.pan_no = null
                        this.gratuity_number = null
                        this.bank_account_number = null
                        this.last_pfno = null
                        this.esic_no = null
                        this.bank = null
                        this.ifsc_code = null
                        this.dateofjoining =null
                        this.dateofretirement = null
                        this.bank_org_list = []
                    });
            },
            getEmpPayRollInfo() {
                const data = {
                    instid: this.instid,
                };
                axios
                    .post("/EmployeeProfile/getEmpAccountDetails", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.official_email_id = res.data.emp_data_list[0].official_email_id;
                            this.pfno = res.data.emp_data_list[0].pfno;
                            this.uan_no = res.data.emp_data_list[0].uan_no;
                            this.pan_no = res.data.emp_data_list[0].pan_no;
                            this.gratuity_number = res.data.emp_data_list[0].gratuity_number;
                            this.bank_account_number = res.data.emp_data_list[0].bank_account_number;
                            this.last_pfno = res.data.emp_data_list[0].last_pfno;
                            this.esic_no = res.data.emp_data_list[0].esic_no;
                            this.bank = res.data.emp_data_list[0].bank;
                            this.ifsc_code = res.data.emp_data_list[0].ifsc_code;
                            this.dateofjoining = res.data.emp_data_list[0].dateofjoining;
                            this.dateofretirement = res.data.emp_data_list[0].dateofretirement;
                            this.dob = res.data.emp_data_list[0].dob;
                            this.employeetype = res.data.emp_data_list[0].employeetype;
                           this.bank_org_list = res.data.bank_org_list;
                        }
                        else{
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
    };
</script>
<style scoped></style>
